import React from "react";
import styles from "./style.module.scss";
import { useSelector } from "react-redux";
import { RootState } from "../../../state";
import { isEqual } from "lodash";
import { getPitWindowOpenCloseBars } from "../../../lib/race";
import { numericalString } from "../../../types";

export default function PitWindowBars({
  carColour,
  carNumber,
}: {
  carColour: string;
  carNumber?: string;
}) {
  const lapTableData = useSelector(
    (state: RootState) => state.raceData[carColour]?.lapTable ?? {},
    isEqual,
  );

  const currentLap = useSelector(
    (state: RootState) => state.raceData[carColour]?.raceConfig?.currentLap,
  );

  const attackStatus = useSelector(
    (state: RootState) =>
      state.aks.v2.FiaFormulaE?.attackMode?.[carNumber as numericalString]
        ?.active ?? false,
  );

  const raceConfig = useSelector(
    (state: RootState) => state.raceData[carColour]?.raceConfig,
    isEqual,
  );

  const strategyImport = useSelector(
    (state: RootState) => state.imports.imports.strategy?.data,
    isEqual,
  );

  const pitWindowOpenCloseValues = raceConfig
    ? getPitWindowOpenCloseBars(
        currentLap ?? 1,
        lapTableData,
        raceConfig,
        attackStatus,
        strategyImport?.NLapsPitWindowOpenOffset ?? 0,
        strategyImport?.NLapsPitWindowCloseOffset ?? 0,
      )
    : null;

  const openLaps = pitWindowOpenCloseValues?.open ?? null;
  const closeLaps = pitWindowOpenCloseValues?.close ?? null;
  console.log(pitWindowOpenCloseValues);
  const getPercent = (value: number) => (value % 1) * 100;

  return (
    <div className={styles.container}>
      <div className={styles.row}>
        <span className={styles.label}>
          Open: {openLaps !== null ? Math.floor(openLaps) : "-"}
        </span>
        <div className={styles.track}>
          {openLaps !== null && (
            <div
              className={`${styles.fill} ${styles.openFill}`}
              style={{ width: `${getPercent(openLaps)}%` }}
            />
          )}
        </div>
      </div>
      <div className={styles.row}>
        <span className={styles.label}>
          Close: {closeLaps !== null ? Math.floor(closeLaps) : "-"}
        </span>
        <div className={styles.track}>
          {closeLaps !== null && (
            <div
              className={`${styles.fill} ${styles.closeFill}`}
              style={{ width: `${getPercent(closeLaps)}%` }}
            />
          )}
        </div>
      </div>
    </div>
  );
}
